module.exports = __webpack_public_path__ + "media/application/images/svgs/corner-up-right-cd6c89537a9f8f336d4f49ff67ed336e.svg";